/**
 * Color de badge por status de Monday (to-do status). Diferencia cada etapa del
 * flujo; "PAY TO HO" y "To Pay" van en colores distintos. Default gris.
 */
const STATUS_COLOR: Record<string, string> = {
  'Waiting 1st Check': 'blue',
  'Waiting Depreciation': 'teal',
  'Waiting more Payments': 'blue',
  'Waiting repair Check': 'teal',
  'Invoice to do': 'orange',
  'Last Invoice to Do': 'orange',
  'Waiting Revision': 'amber',
  'Waiting Clear Check': 'purple',
  'To Pay': 'green',
  'PAY TO HO': 'pink',
  'Waiting from Mortgage': 'slate',
  'Needs Mortgage Info': 'slate',
  'Repair (No Payment to HO or CO)': 'slate',
  'Homeowner with check': 'purple',
  'Owed to Us': 'red',
  Bounced: 'red',
  'Waiting Paym Approval': 'amber',
  HOLD: 'red',
  Finalized: 'gray',
  // Ciclo de vida del claim (intake → claims → cierre).
  Lead: 'slate',
  'Contract Sent': 'blue',
  'Contract Signed': 'teal',
  'Waiting Documents': 'amber',
  'Claim Review': 'amber',
  'Claim Accepted': 'green',
  'Claim Not Accepted': 'red',
  Denied: 'red',
  'Welcome Call': 'amber',
  'Ready to be filed': 'orange',
  'Ready to File': 'orange',
  'Claim in': 'blue',
  'Insurance inspection': 'teal',
  'Re-inspection request/ed': 'amber',
  'Re-inspection requested': 'amber',
  'Needs Reschedule': 'orange',
  'Waiting approval': 'amber',
  'ATR request': 'purple',
  'Review ATR': 'purple',
  'ATR Follow up': 'blue',
  'ATR Rejected': 'red',
  Approved: 'green',
  'Approved for Repairs': 'green',
  Supplementing: 'orange',
  'Supplement Resolved': 'green',
  'Waiting /Completion': 'slate',
  'Project Completed': 'green',
  'Claim CANCELLED': 'red',
};

export function statusColor(status: string | null | undefined): string {
  if (!status) return 'gray';
  return STATUS_COLOR[status] ?? 'slate';
}

/**
 * Estilo inline {bg, fg} del status — para pintar SELECTS/inputs con el color del
 * status (como Monday), consistente con la paleta de los badges (.badge.* en
 * styles.css). Un solo lugar → el mismo color en todos lados.
 */
const CLASS_HEX: Record<string, { bg: string; fg: string }> = {
  green: { bg: '#dcf3e5', fg: '#15803d' },
  orange: { bg: '#ffe9d6', fg: '#c2570b' },
  red: { bg: '#fde5e5', fg: '#dc2626' },
  gray: { bg: '#eef1f4', fg: '#6b7280' },
  blue: { bg: '#e7efff', fg: '#2563eb' },
  purple: { bg: '#f1e9ff', fg: '#7c3aed' },
  teal: { bg: '#def5f0', fg: '#0d9488' },
  amber: { bg: '#fdf0d9', fg: '#b45309' },
  pink: { bg: '#fde9f3', fg: '#db2777' },
  slate: { bg: '#eaeef3', fg: '#475569' },
};
export function statusStyle(status: string | null | undefined): React.CSSProperties {
  const c = CLASS_HEX[statusColor(status)] ?? CLASS_HEX.gray!;
  return { background: c.bg, color: c.fg, fontWeight: 600, borderColor: 'transparent' };
}

/** Días transcurridos desde una fecha ISO (para "días en este status"). */
export function daysSince(iso: string | null | undefined): number | null {
  if (!iso) return null;
  return Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
}
